import type { I18nOptions } from "vue-i18n";
import C from "@/utils/constants";

function loadLocaleMessages(): Record<string, Record<string, string>> {
  type LocaleMessages = Record<string, string>;
  type LocaleModule = LocaleMessages | { default: LocaleMessages };
  const modules = import.meta.glob("./lang/*.json", { query: "?json", eager: true }) as Record<
    string,
    LocaleModule
  >;
  const messages: Record<string, Record<string, string>> = {};

  Object.entries(modules).forEach(([path, mod]) => {
    // path: './lang/en.json' -> locale 'en'
    const match = path.match(/\.\/lang\/(.+?)\.json$/);
    const locale = match ? match[1] : path;
    // mod may be the JSON object directly or { default: obj }
    const msg = (mod && (mod.default ?? mod)) as Record<string, string> | undefined;
    if (msg && typeof msg === "object") {
      messages[locale] = msg;
    }
  });

  return messages;
}

const i18nConfig: I18nOptions = {
  legacy: false,
  locale: C.DEFAULT_LOCALE as string,
  fallbackLocale: C.FALLBACK_LOCALE as string,
  messages: loadLocaleMessages(),
};

export default i18nConfig;
